export default __webpack_public_path__ + "static/media/lakshya.bdea876c.jpg";